import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from "@backstage/theme";

import { montserratRegular } from "./fonts";



const headerTheme = genPageTheme({ colors: ["#0084D5", "#3B6995"], shape: shapes.wave });

export const kvLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: "#3B6995",
      },
      secondary: {
        main: "#082D5B",
      },
      info: {
        main: "#0084D5",
      },
      error: {
        main: "#C3492F",
      },
      banner: {
        info: "#0084D5",
        error: "#C3492F",
        text: "#FFFFFF",
        link: "#0084D5",
      },
      navigation: {
        background: "#343131",
        indicator: "#0084D5",
        color: "#b5b5b5",
        selectedColor: "#FFFFFF",
        navItem: {
          hoverBackground: "#404040",
        },
        submenu: {
          background: "#404040",
        },
      },
      tabbar: {
        indicator: "#0084D5",
      },
      bursts: {
        fontColor: "#FEFEFE",
        slackChannelText: "#ddd",
        backgroundColor: {
          default: "#7E8C17",
        },
        gradient: {
          linear: "linear-gradient(-137deg, #0084D5 0%, #3B6995 100%)",
        },
      },
    },
    defaultPageTheme: "home",
  }),
  pageTheme: {
    home: headerTheme,
    documentation: headerTheme,
    tool: headerTheme,
    service: headerTheme,
    website: headerTheme,
    library: headerTheme,
    other: headerTheme,
    app: headerTheme,
    apis: headerTheme,
    card: headerTheme,
  },
  fontFamily: montserratRegular.fontFamily,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "@font-face": [montserratRegular],
      },
    },
  },
});